import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VehicleShowcaseCards from '../components/VehicleShowcaseCards';
import FAQ2 from '../components/FAQ2';

export default function OurFleet() {
  return (
    <div>
      {/* Hero Section */}
      <section 
        className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
        style={{
          backgroundImage: 'url(blog12.png)',
        }}
      >
        <Header />

        {/* Hero Content */}
        <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
          <div className="max-w-5xl text-center text-white">
            <h1 className="font-bold leading-snug text-white">
              Our Fleet
            </h1>
            <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
              <a href="/" className="hover:text-logo-green">Home</a>
              <span>-</span>
              <span className="text-logo-green">Our Fleet</span>
            </div>
          </div>
        </div>
      </section>

      {/* Fleet Introduction Section */}
      <div className="text-center mt-8 sm:mt-12 lg:mt-16 mb-8 sm:mb-10 lg:mb-12 px-4">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">Our Fleet</h2>
        <p className="text-base sm:text-lg text-gray-900">Top-Rated Rides & Transfers</p>
      </div>
       
        <section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* Image Side - First on mobile, left on desktop */}
            <div className="order-1 lg:order-1">
              <img 
                src="fleet6.png" 
                alt="Luxury Fleet" 
                className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Text Side - Second on mobile, right on desktop */}
            <div className="order-2 lg:order-2">
              <h2 className="text-2xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
                New York Limo Service – Luxury Rides with  Majestic Voyage USA
              </h2>
              <p className="text-base sm:text-lg mb-3 sm:mb-4 leading-relaxed text-gray-900">
               Looking for a stylish limo service in New York City? Drink to Majestic Voyage USA, the most trusted
               name for luxury auto service in NYC.
               We offer ultraexpensive limousines, black buses, and administrative SUVs for field transfers,
               marriages, business trip, events, and nights out.

              </p>
              <p className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed text-gray-900">
              Our New York limo service is each about comfort, finesse, and professionalism. Whether you're
              a original, sightseer, or commercial rubberneck, we make sure your lift through New York feels
              smooth, swish, and stress-free.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/booknow" 
                  className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
                >
                  BOOK NOW
                </a>
                <a 
                  href="tel:+17182004140" 
                  className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
                >
                  CALL NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vehicle Showcase Cards Section */}
      <VehicleShowcaseCards />
      
      
      
<FAQ2/>
      
      
      <Footer />
    </div>
  );
}







